import React from "react";
import { Link } from "react-router-dom";
import SiteShell from "../components/layout/SiteShell";
import ContentPageLayout from "../components/content/ContentPageLayout";
import SEO from "../components/seo/SEO";

export default function PrivacyPage() {
  return (
    <SiteShell>
      <SEO
        title="Privacy Policy | MossMatrix"
        description="MossMatrix privacy policy: how we handle checkout data, emails, and cookies. Concise launch version to be reviewed by your counsel."
        path="/privacy-policy"
      />
      <ContentPageLayout
        eyebrow="Legal"
        title="Privacy Policy"
        subtitle="This is a concise launch draft. Have your legal counsel adapt it to your jurisdiction, payment processors, and analytics tools before relying on it in court."
      >
        <div className="max-w-3xl text-sm text-botanical/85 space-y-4 leading-relaxed">
          <p>
            MossMatrix collects the information you provide at checkout (name, email, shipping details) and data required by Stripe to process payments. We do not sell personal data.
          </p>
          <p>
            Our admin tools use Supabase Auth for protected access; access logs may be retained for security. Cookies follow your cookie banner settings once implemented.
          </p>
          <p>
            To request deletion or export of your data, email{" "}
            <a href="mailto:info@mossmatrix.com" className="underline">
              info@mossmatrix.com
            </a>
            .
          </p>
        </div>
        <p className="mt-10 text-sm">
          <Link to="/" className="underline hover:text-forest">
            Home
          </Link>
        </p>
      </ContentPageLayout>
    </SiteShell>
  );
}
